import { Directive } from '@angular/core';

@Directive({
  selector: '[brunskerMultipleStackPrice]',
})
export class MultipleStackPriceDirective {
  constructor() {}

  validateMultiple(value: string | number, controlValue: string | number) {
    const numberValue = Number(value);
    const controlNumberValue = Number(controlValue);
    const decreasedValue = (Math.floor as any)(controlNumberValue, -1);

    if (controlNumberValue > numberValue) return numberValue * decreasedValue;

    return numberValue;
  }
}
